export default {
  allCell: {
    width: '60px'
  },
  all: {
    width: '30px'
  },
  dateCell: {
    width: '120px',
    textAlign: 'left'
  },
  date: {
    width: '40px'
  },
  comment: {
    width: '75px'
  },
  commentCell: {
    textAlign: 'left'
  },
  statusCell: {
    width: '100px'
  },
  status: {
    width: '50px'
  },
  contextMenuCell: {
    width: '60px'
  }
}
